export const getQuickViewLoader = (state) => {
  return state?.PageLoader?.quickViewLoader;
};

export const getLoaderStatus = (state) => {
  return state?.PageLoader?.loaderState;
};

export const getLogoutInProgress = (state) => {
  return state?.PageLoader?.logoutInProgress;
};

export default { getQuickViewLoader, getLoaderStatus };
